import { CloseSquare, InfoCircle } from "iconsax-react";
import React, { useState } from "react";
import { api } from "../../utils/axios";
import { toast } from "react-toastify";
type PropsType = {
	user_id: number;
	user_name: string;
	setUserId: (user_id: number | null) => void;
};

const RemoveUserConfirmModal = ({
	user_id,
	setUserId,
	user_name,
}: PropsType) => {
	const [requestIsLoading, setRequestIsLoading] = useState(false);

	const handleConfirm = () => {
		if (requestIsLoading) return;
		setRequestIsLoading(true);
		api
			.post(
				"/remove_user",
				{
					user_id: user_id,
				},
				{
					headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
				},
			)
			.then((response) => {
				toast.success("کاربر با موفقیت حذف شد");
				setUserId(null);
			})
			.catch((error) => {
				toast.error(error.response.data?.error);
			})
			.finally(() => {
				setRequestIsLoading(false);
			});
	};

	return (
		<div className="taskdetails-modal-overlay">
			<div className="taskdetails-modal tw-max-w-lg mx-auto">
				<button
					className="taskdetails-modal-close"
					onClick={() => setUserId(null)}
				>
					&times;
				</button>
				<div className="taskdetails-modal-icon">
					<InfoCircle size={38} color="#3b82f6" variant="Bold" />
				</div>
				<div className="taskdetails-modal-message tw-text-blue-500">
					آیا از حذف کاربر
					<span className={"tw-text-red-500 !tw-text-xl"}>
						{" " + user_name + " "}
					</span>
					اطمینان دارید؟
				</div>
				<div className="taskdetails-modal-actions mt-5">
					<button
						className="taskdetails-actions-btn tw-text-red-600 tw-border-red-600 tw-w-1/2 tw-flex-shrink-0 hover:tw-bg-red-50"
						onClick={() => handleConfirm()}
					>
						حذف کاربر
					</button>
					<button
						className="taskdetails-modal-cancel-btn tw-w-1/2 tw-flex-shrink-0 tw-flex tw-justify-center"
						onClick={() => setUserId(null)}
					>
						انصراف
					</button>
				</div>
			</div>
		</div>
	);
};
export default RemoveUserConfirmModal;
